module.exports = __webpack_public_path__ + "img/OM.c04ddb40.svg";